export default __webpack_public_path__ + "media/images/images/carousel/22-3049b452c738fd109ab9318a2c5a605f.jpg";